import { useEffect } from "react";

const setMeta = (sel, attrs) => {
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement(attrs.rel ? "link" : "meta"); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  el.setAttribute("data-seo", "1");
};

export function useSeo({ title, description, canonical, image, type = "website", jsonld, noindex }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) { setMeta('meta[name="description"]', { name: "description", content: description }); setMeta('meta[property="og:description"]', { property: "og:description", content: description }); }
    if (title) setMeta('meta[property="og:title"]', { property: "og:title", content: title });
    setMeta('meta[property="og:type"]', { property: "og:type", content: type });
    setMeta('meta[property="og:locale"]', { property: "og:locale", content: "it_IT" });
    const url = canonical || window.location.origin + window.location.pathname;
    setMeta('link[rel="canonical"]', { rel: "canonical", href: url });
    setMeta('meta[property="og:url"]', { property: "og:url", content: url });
    if (image) setMeta('meta[property="og:image"]', { property: "og:image", content: image.startsWith("http") ? image : window.location.origin + image });
    setMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1" });
    document.head.querySelectorAll('script[type="application/ld+json"][data-seo]').forEach((s) => s.remove());
    if (jsonld) {
      const s = document.createElement("script"); s.type = "application/ld+json"; s.setAttribute("data-seo", "1");
      s.text = JSON.stringify(jsonld); document.head.appendChild(s);
    }
  }, [title, description, canonical, image, type, noindex, JSON.stringify(jsonld)]); // eslint-disable-line
}

export const orgJsonLd = (base) => ({
  "@context": "https://schema.org", "@graph": [
    { "@type": "Organization", "@id": `${base}/#org`, name: "Qora", legalName: "Labix", url: base, logo: `${base}/qora-logo.png`, email: "support@myqora.it", areaServed: "IT" },
    { "@type": "WebSite", "@id": `${base}/#site`, url: base, name: "Qora", inLanguage: "it-IT", publisher: { "@id": `${base}/#org` } },
    { "@type": "SoftwareApplication", name: "Qora", applicationCategory: "BusinessApplication", operatingSystem: "Web", inLanguage: "it-IT", url: base,
      description: "Suite per QR dinamici con statistiche, pagine Qora Link e menù digitali con allergeni e PDF.",
      offers: [{ "@type": "Offer", name: "Qora QR", price: "9.90", priceCurrency: "EUR" }, { "@type": "Offer", name: "Qora Link", price: "9.90", priceCurrency: "EUR" },
        { "@type": "Offer", name: "Qora Menu", price: "14.90", priceCurrency: "EUR" }, { "@type": "Offer", name: "Qora Complete", price: "24.90", priceCurrency: "EUR" }] },
  ],
});

export const faqJsonLd = (items) => ({ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: items.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) });
